import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    info: {
      main: '#0071EB',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 16,
          fontWeight: 700,
          fontWeightLight: 'normal',
          textTransform: 'none',
        },
      },
    },
  },
});
